<template>
  <v-sheet class="bonus-item-card" color="white" min-width="280px" max-width="328px">
    <v-img v-if="imagePath" :src="imagePath" max-height="272px">
      <template #placeholder>
        <div class="image-placeholder"></div>
      </template>
    </v-img>
    <div v-else class="image-placeholder"></div>

    <div class="font--h4" v-text="title"></div>

    <span class="font--note" style="color: #777C87" v-text="description"></span>

    <div class="d-flex flex-row mt-2 align-center">
      <div class="d-flex flex-row align-baseline" style="column-gap: 8px;">
        <span class="font--money-label" style="color: #4971D0" v-text="price.toLocaleString('ru-ru')"></span>
        <v-img class="my-auto" src="@/assets/img/bonus-coin.svg" max-width="16px" max-height="16px" />
      </div>

      <v-spacer />

      <v-btn
        color="primary"
        :loading="loading"
        :disabled="disabled"
        depressed
        @click="$emit('order', { alias, bonus_good_id, price, event: $event })"
      >Купить</v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    alias: {
      type: String,
      required: true,
    },

    bonus_good_id: {
      type: Number,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true,
    },

    price: {
      type: Number,
      required: true,
    },

    imagePath: {
      type: String,
      required: false,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.bonus-item-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 8px;

  padding: 16px;
  box-shadow: 0px 6px 16px 0px #2227331F !important;
}

.image-placeholder {
  width: 100%;
  min-height: 260px;
}
</style>
